module.exports = __webpack_public_path__ + "static/media/bluebird-midflap.fcb5a4cd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/res/bluebird-midflap.png
 ** module id = 181
 ** module chunks = 0
 **/